import { useT } from '@/i18n/useT';
import { TELEGRAM } from '@/lib/config';

/**
 * The two official $mallX Telegram destinations.
 *
 * Rendered on Settings, which is the one bot screen a customer opens looking
 * for things about their account rather than about a trade, and it is in the
 * bottom nav so it is reachable from anywhere in two taps.
 *
 * Both open in a new context (`_blank` + `noopener`): on a phone that hands
 * off to the Telegram app, and in the installed PWA it avoids replacing the
 * dashboard with Telegram and stranding the customer outside the app with no
 * back button.
 */

function TelegramIcon() {
  return (
    <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false">
      <circle cx="12" cy="12" r="12" fill="#29a9eb" />
      <path
        d="M5.5 11.9l11-4.24c.51-.19.96.12.79.9l-1.87 8.83c-.14.66-.53.82-1.08.51l-2.99-2.2-1.44 1.39c-.16.16-.29.29-.6.29l.21-3.04 5.53-5c.24-.21-.05-.33-.37-.12l-6.83 4.3-2.94-.92c-.64-.2-.65-.64.13-.95z"
        fill="#fff"
      />
    </svg>
  );
}

export function CommunityCard() {
  const { t } = useT();

  const rows = [
    { href: TELEGRAM.channel, title: t('community.channel'), sub: t('community.channelSub') },
    { href: TELEGRAM.community, title: t('community.group'), sub: t('community.groupSub') },
  ];

  return (
    <section className="bot-card">
      <div className="bot-card-head"><h2>{t('community.title')}</h2></div>
      <p className="muted">{t('community.blurb')}</p>
      <ul className="bot-links">
        {rows.map((r) => (
          <li key={r.href}>
            <a className="bot-link-row" href={r.href} target="_blank" rel="noopener noreferrer">
              <span className="bot-link-icon"><TelegramIcon /></span>
              <span className="bot-link-text">
                <strong>{r.title}</strong>
                <span className="muted">{r.sub}</span>
              </span>
              <span className="bot-link-arrow" aria-hidden="true">›</span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
}
